export default __webpack_public_path__ + "images/SpeakersPhotos/Monica Diaz Ponte.jpg?de04476a";